<section class="comparison-section">

    <div class="container-redesign">

        <div class="comparison-section__wrapper">

            <div class="comparison-section__content">

                <h2 class="comparison-section__title">
                    Why AI-driven mental
                    health <span>monitoring
                    outperforms traditional
                    approaches</span>
                </h2>

                <p class="comparison-section__description">
                    AltheaCare combines predictive analysis, automation,
                    and a unified platform to help teams intervene
                    sooner and operate at scale.
                </p>

                <a
                    routerLink="/contact-redesign"
                    class="comparison-section__button">

                    <span>TALK TO OUR TEAM</span>

                    <img
                        src="/assets/img/redesign/flecha.svg"
                        alt=""
                        class="comparison-section__button-icon">

                </a>

            </div>

            <div class="comparison-section__table">

                <div class="comparison-section__column">

                    <div class="comparison-section__heading">

                        Traditional
                        Monitoring

                    </div>

                    <div
                        class="comparison-section__row comparison-section__row--secondary"
                        *ngFor="let item of traditionalFeatures; trackBy: trackByText">

                        {{ item.text }}

                    </div>

                </div>

                <div class="comparison-section__column">

                    <div class="comparison-section__heading comparison-section__heading--logo">

                        <img
                            src="/assets/img/redesign/althea-logo.png"
                            alt="Althea">

                    </div>

                    <div
                        class="comparison-section__row comparison-section__row--primary"
                        *ngFor="let item of altheaFeatures; trackBy: trackByText">

                        {{ item.text }}

                    </div>

                </div>

            </div>

        </div>

    </div>

</section>